// takes the transformed data and returns an object with tabs as keys and an array of instances as values

import {
  FieldTypes,
  IFieldInstance,
} from "../../types/fieldInstance.interface";
import { getRLFormFields } from "../helpers/relatedListHelpers";
import { transformedData } from "./getTransformedData";

const { unnamed: unnamedFields, ...namedFields } = transformedData;

// iterate over object, find tabs and return arrays

const getTabSeparatedData = (inputObject: {
  [x: string]: any[] | IFieldInstance[];
}) => {
  const tabs: any = {};
  for (let key in inputObject) {
    for (let field of inputObject[key]) {
      const tabArray = field.tab;
      if (tabArray.length < 0) return [];
      let currentTab: string;
      tabArray.forEach(function (tab: string[], index: number) {
        if (currentTab === tab[1]) return;
        if (!tabs[tab[1]]) {
          tabs[tab[1]] = [field];
        } else {
          tabs[tab[1]].push(field);
        }
        currentTab = tab[1];
      });
    }
  }
  return tabs;
};

const _tabSeparatedData = getTabSeparatedData(namedFields);

function insertElementsAt(array: any[], index: any, elements: any[]) {
  array.splice(index, 1, ...elements);
  return array;
}

const addInlineRLFields = (tabFields: any) => {
  const updatedTabs = { ...tabFields };
  for (const [key, value] of Object.entries(tabFields)) {
    const updatedFields = [...(value as IFieldInstance[])];
    (value as IFieldInstance[]).forEach((field, index) => {
      if (field.fieldType === FieldTypes.InlineRelatedList) {
        const formFieldsObj = getRLFormFields(field.fieldName);
        const formFields = Object.values(formFieldsObj).flat();
        formFields && insertElementsAt(updatedFields, index, formFields);
      }
    });
    updatedTabs[key] = updatedFields;
  }
  return updatedTabs;
};

export const tabSeparatedData = addInlineRLFields(_tabSeparatedData);
